// @ts-nocheck
import { PackagingAdviceFormFieldValues } from "@store/Framework/Store/Greif/Components/PackagingAdviceForm/PackagingAdviceFormState";
import { createHandlerChainRunnerOptionalParameter, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type Parameter = Array<keyof PackagingAdviceFormFieldValues>;
type HandlerType = Handler<Parameter>;

export const DispatchSaveDraftFieldValues: HandlerType = props => {
    props.dispatch({
        type: "Greif/Components/PackagingAdviceForm/SaveDraftFieldValues",
        keys: props.parameter,
    });
};

export const chain = [DispatchSaveDraftFieldValues];

const saveDraftFieldValues = createHandlerChainRunnerOptionalParameter(chain, [] as Parameter, "SaveDraftFieldValues");

export default saveDraftFieldValues;
